import config from './common.js'; //公共变量
import app from './app.js';
import Cookies from 'js-cookie';
import http from './ajax.js'; //ajax请求
const browser = {
  versions: (function() {
    var u = navigator.userAgent;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Firefox') > -1, //火狐内核Gecko
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android
      iPhone: u.indexOf('iPhone') > -1, //iPhone
      iPad: u.indexOf('iPad') > -1, //iPad
      webApp: u.indexOf('Safari') > -1, //Safari
      user: u
    };
  })()
};
// 工具
var tools = {
  android: browser.versions.android, //安卓
  trident: browser.versions.trident, //IE内核
  presto: browser.versions.presto, //opera内核
  webKit: browser.versions.webKit, //苹果、谷歌内核
  gecko: browser.versions.gecko, //火狐内核Gecko
  mobile: browser.versions.mobile, //是否为移动终端
  ios: browser.versions.ios, //ios
  iPhone: browser.versions.iPhone, //iPhone
  iPad: browser.versions.iPad, //iPad
  webApp: browser.versions.webApp, //Safari
  user: browser.versions.user, //Safari
  // 设置网页标题
  setWebTitle(title) {
    setTimeout(function() {
      document.getElementsByTagName('title')[0].innerText = title;
    }, 100);
  },
  userInfo: JSON.parse(localStorage.getItem('jzy_user') || '{}'),
  // 是否是ok保商户
  isOKbao(merchantNo) {
    if(merchantNo) {
      if(merchantNo  == '260580000000800') {
        return true;
      }
    } else if (this.userInfo.merchantNo == '260580000000800') {
      return true;
    }
    return false;
  },
  //是否梧桐树
  isWTS(merchantNo) {
    if(merchantNo) {
      if(merchantNo  == '260580000000800-wh') {
        return true;
      }
    } else if (this.userInfo.merchantNo == '260580000000800-wh') {
      return true;
    }
    return false;
  },
  // 是否是如意保保
  isRYBB(merchantNo) {
    if(merchantNo) {
      if(merchantNo  == 'ryggcm') {
        return true;
      }
    } else if (this.userInfo.merchantNo == 'ryggcm') {
      return true;
    }
    return false;
  },
  // 是否是ok团保
  isOKTX(merchantNo) {
    if(merchantNo) {
      if(merchantNo  == 'txokb') {
        return true;
      }
    } else if (this.userInfo.merchantNo == 'txokb') {
      return true;
    }
    return false;
  },
  
  isRYBB(merchantNo) {
    if(merchantNo) {
      if(merchantNo  == 'ryggcm') {
        return true;
      }
    } else if (this.userInfo.merchantNo == 'ryggcm') {
      return true;
    }
    return false;
  },
  isIOS: function() {
    /* istanbul ignore next */
    return /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
  },
  //微信
  isWeiXin: function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  //企业微信
  isQyWeiXin: function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/wxwork/i) == 'wxwork') {
      return true;
    } else {
      return false;
    }
  },
  //过滤空格
  trim: function(val) {
    return val.replace(/(^\s*)|(\s*$)/g, '');
  },
  //删除地址栏参数
  delQueStr: function(url, ref) {
    var str = '';
    if (url.indexOf('?') != -1) {
      str = url.substr(url.indexOf('?') + 1);
    } else {
      return url;
    }
    var arr = '';
    var returnurl = '';
    var setparam = '';
    if (str.indexOf('&') != -1) {
      arr = str.split('&');
      for (var i in arr) {
        if (arr[i].split('=')[0] != ref) {
          returnurl = returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&';
        }
      }
      return url.substr(0, url.indexOf('?')) + '?' + returnurl.substr(0, returnurl.length - 1);
    } else {
      arr = str.split('=');
      if (arr[0] == ref) {
        return url.substr(0, url.indexOf('?'));
      } else {
        return url;
      }
    }
  },
  //设置本地储存
  setLocal: function(name, value, type) {
    var curTime = new Date().getTime();
    if (!type || type == 2) {
      //默认设置-之前存在则使用创建时间
      var data = localStorage.getItem(name);
      if (!data || data == 'null') {
        localStorage.setItem(
          name,
          JSON.stringify({
            data: value,
            time: curTime
          })
        );
      } else {
        var dataObj = JSON.parse(data);
        var setTime = dataObj.time;
        localStorage.setItem(
          name,
          JSON.stringify({
            data: value,
            time: setTime
          })
        );
      }
    } else if (type == 1) {
      //type:1重新创建
      localStorage.setItem(
        name,
        JSON.stringify({
          data: value,
          time: curTime
        })
      );
    }
  },
  //获取本地储存
  getLocal: function(name, exp) {
    var data = localStorage.getItem(name);
    var dataObj = JSON.parse(data);
    if (!exp) {
      var exp = 1000 * 60 * 60 * 24 * 3;
    }
    if (dataObj && new Date().getTime() - dataObj.time > exp) {
      localStorage.removeItem(name);
      console.log('信息已过期');
      return null;
    } else {
      var dataObjDatatoJson = !dataObj ? null : dataObj.data;
      return dataObjDatatoJson;
    }
  },

  /*
   * 深复制
   * params
   * -destination  被赋值的新对象
   * -source  取值的对象
   * -miss  忽略的对象
   * */
  deepCopy: function(destination, source, miss) {
    for (var p in source) {
      if (_.isArray(p, miss) > -1) {
        return;
      }
      if (getType(source[p]) == 'array' || getType(source[p]) == 'object') {
        destination[p] = getType(source[p]) == 'array' ? [] : {};
        arguments.callee(destination[p], source[p]);
      } else {
        destination[p] = source[p];
      }
    }

    function getType(o) {
      var _t;
      return ((_t = typeof o) == 'object' ? (o == null && 'null') || Object.prototype.toString.call(o).slice(8, -1) : _t).toLowerCase();
    }
  },
  getStorage(key, isSession) {
    const storage = isSession ? sessionStorage : localStorage;
    if (storage[key]) {
      let out = storage[key];
      try {
        out = JSON.parse(storage[key]);
      } catch (error) {
        console.log('解析localStorage.' + key + '失败', error);
      }
      return out;
    }
  },
  setStorage(key, data, isSession) {
    if (typeof data == 'object') {
      try {
        data = JSON.stringify(data);
      } catch (error) {
        console.log('解析localStorage.' + key + '失败', error);
      }
    }
    if (isSession) {
      sessionStorage.setItem(key, data);
    } else {
      localStorage.setItem(key, data);
    }
  },
  dateFormat(date, fmt) {
    if (!date) {
      return;
    }
    if (typeof date == 'string') {
      date = new Date(date.replace(/-/gm, '/'));
    }
    let ret;
    const opt = {
      'y+': date.getFullYear().toString(), // 年
      'M+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'h+': date.getHours().toString(), // 时
      'm+': date.getMinutes().toString(), // 分
      's+': date.getSeconds().toString() // 秒
      // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt);
      if (ret) {
        fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
      }
    }
    return fmt;
  },

  formatSeconds: function(value) {
    var secondTime = parseInt(value); // 秒
    var minuteTime = 0; // 分
    var hourTime = 0; // 小时
    if (secondTime >= 60) {
      //如果秒数大于60，将秒数转换成整数
      //获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60);
      //获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60);
      //如果分钟大于60，将分钟转换成小时
      if (minuteTime >= 60) {
        //获取小时，获取分钟除以60，得到整数小时
        hourTime = parseInt(minuteTime / 60);
        //获取小时后取佘的分，获取分钟除以60取佘的分
        minuteTime = parseInt(minuteTime % 60);
      }
    }

    var result = '';
    if (secondTime == 0 && (minuteTime > 0 || hourTime > 0)) {
    } else {
      result = parseInt(secondTime) + '秒';
    }
    if (minuteTime > 0) {
      result = '' + parseInt(minuteTime) + '分钟' + result;
    }
    if (hourTime > 0) {
      result = '' + parseInt(hourTime) + '小时' + result;
    }
    return result;
  },
  //获取地址栏参数
  getQueryStringByName: function(name) {
    var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
    if (result == null || result.length < 1) {
      return '';
    }
    return result[1];
  },
  outLogin(url = location.href) {
    localStorage.removeItem('jzy_token');
    // localStorage.removeItem("jzy_openid");
    localStorage.removeItem('jzy_wxInfo');
    localStorage.removeItem('jzy_auth');
    localStorage.removeItem('jzy_user');
    localStorage.removeItem('isServiceFeeShow');
    localStorage.removeItem('wechatId');
    if(sessionStorage.orgId) {
      localStorage['token' + sessionStorage.orgId] = '';
      localStorage['user' + sessionStorage.orgId] = '';
    }
    sessionStorage.removeItem('ignoreAuth');
    sessionStorage.jzyLoginPage = url;
    location.replace(localStorage.orgId ? '/apps/login?orgId=' + localStorage.orgId : '/apps/login');
  },
  getAppLoginInfo() {
    return new Promise((resolve, reject) => {
      if (config.isApp) {
        app.deviceready(res => {
          app.getDeviceInfo(res => {
            console.log('getDeviceInfo', res);
            if (typeof res == 'string') {
              try {
                res = JSON.parse(res);
              } catch (error) {}
            }
            localStorage.jzyVersion = res.mainVersion;
          });
          app.getUserInfo(
            async res => {
              console.log(res);
              if (typeof res == 'string') {
                try {
                  res = JSON.parse(res);
                } catch (error) {}
              }

              try {
                let userData = {};
                if (res.data) {
                  localStorage.jzy_token = res.data.token;
                  userData = res.data;
                } else {
                  localStorage.jzy_token = res.token;
                  userData = res;
                }
                localStorage.jzy_user = JSON.stringify(userData);
                if (!userData.merchantNo) {
                  await tools.getMerchantNo();
                }
                tools.userInfo = JSON.parse(localStorage.getItem('jzy_user') || '{}');
                resolve();
              } catch (error) {
                console.log(error);
                console.log('保存用户信息异常');
                resolve();
              }
            },
            res => {
              console.log('error', res);
              resolve();
            }
          );
        });
      } else {
        resolve();
      }
    });
  },
  //获取商户号
  getMerchantNo() {
    return new Promise((resolve, reject) => {
      if(!localStorage.jzy_token) {
        resolve();
        return;
      }
      http({
        url: '/app/content/slient',
        type: 'GET',
        data: {}
      }).then(res => {
        if(!res.data.user || !res.data.user.merchantNo) {
          resolve();
          return;
        }
        resolve(res.data.user.merchantNo);
        let jzy_user = JSON.parse(localStorage.jzy_user);
        if (!jzy_user.merchantNo) {
          jzy_user.merchantNo = res.data.user.merchantNo;
          localStorage.jzy_user = JSON.stringify(jzy_user);
        }
      });
    });
  },
  // 保存链接orgId
  setOrgId() {
    const orgId = tools.getQueryStringByName('orgId') || localStorage.orgId || '';
    if (orgId) {
      localStorage.orgId = orgId;
      sessionStorage.orgId = orgId;
      if(!config.isApp) {
        if(localStorage.storageVer != config.ver) {
          localStorage.jzy_token = localStorage['token' + orgId] = '';
          localStorage.jzy_user = localStorage['user' + orgId] = '';
          localStorage.regToken = localStorage['regToken' + orgId] = '';
          localStorage.storageVer = config.ver;
        }
        localStorage.jzy_token = localStorage['token' + orgId] || '';
        localStorage.jzy_user = localStorage['user' + orgId] || '';
        localStorage.regToken = localStorage['regToken' + orgId] || '';
      }
    }
  },
  //h5 环境刷新token
  setRefreshToken() {
    return new Promise((resolve, reject) => {
      console.log('isApp:', config.isApp);
      if (config.isApp || !localStorage.jzy_token) {
        resolve();
      } else {
        http({
          url: '/api/userBase/refreshToken',
          type: 'GET',
          hideAlert: true,
          data: {}
        })
          .then(res => {
            if (res.data && res.httpCode == 1) {
              localStorage.jzy_token = res.data;
              if(sessionStorage.orgId) {
                localStorage['token' + sessionStorage.orgId] = localStorage.jzy_token;
                localStorage['user' + sessionStorage.orgId] = localStorage.jzy_user;
              }
            }
            resolve();
          })
          .catch(() => {
            resolve();
          });
      }
    });
  },
  dealIosBack() {
    //ios回退前进缓存
    let browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
    if (browserRule.test(navigator.userAgent)) {
      window.onpageshow = function(event) {
        if (event.persisted) {
          //如果是从缓存中读取，则重新刷新页面
          window.location.reload();
        }
      };
    }
  },
  setCookie(key, value, time) {
    Cookies.set(key, value, {
      expires: time
    });
  },
  getCookie(key) {
    return Cookies.get(key);
  },

  /*
   * 当type=1时获取出生日期,type=2时获取性别,type=3时获取年龄
   * */
  IdCard(IdCard, type) {
    if (type === 1) {
      //获取出生日期
      let birthday = IdCard.substring(6, 10) + '-' + IdCard.substring(10, 12) + '-' + IdCard.substring(12, 14);
      return birthday;
    }
    if (type === 2) {
      //获取性别
      if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
        return '1';
      } else {
        return '2';
      }
    }
    if (type === 3) {
      //获取年龄
      var ageDate = new Date();
      var month = ageDate.getMonth() + 1;
      var day = ageDate.getDate();
      var age = ageDate.getFullYear() - IdCard.substring(6, 10) - 1;
      if (IdCard.substring(10, 12) < month || (IdCard.substring(10, 12) === month && IdCard.substring(12, 14) <= day)) {
        age++;
      }
      if (age <= 0) {
        age = 1;
      }
      return age;
    }
  },
  // 下载二维码
  dataToBlob(name, data) {
    data = data.split(',')[1];
    data = window.atob(data);
    var ia = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
      ia[i] = data.charCodeAt(i);
    }
    var blob = new Blob([ia], {
      type: 'image/jpeg'
    });
    const href = window.URL.createObjectURL(blob);
    const downloadElement = document.createElement('a');
    downloadElement.href = href;
    downloadElement.download = name + '.jpg'; // 下载后的文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 下载
    document.body.removeChild(downloadElement); // 下载完成 移除 a
    window.URL.revokeObjectURL(href); // 释放blob对象
  },
  //统计功能次数
  getHealthTest(apiPermissionCode = '') {
    return new Promise((resolve, reject) => {
      http({
        url: '/app/health-test',
        type: 'GET',
        data: {},
        hideAlert: true,
        apiPermissionCode
      })
        .then(res => {
          resolve();
        })
        .catch(() => {
          resolve();
        });
    });
  },
  //判断是否是信小宝，信小宝隐藏服务费
  isXXB() {
    let userInfo = JSON.parse(localStorage.getItem('jzy_user') || '{}');
    return userInfo.merchantNo == '204081000000800';
  },
  // 阿拉伯数字转汉字
  numberTransform(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];
    if (!num || isNaN(num)) return '零'
    var english = num.toString().split('')
    var result = ''
    for (var i = 0; i < english.length; i++) {
      var des_i = english.length - 1 - i// 倒序排列设值
      result = arr2[i] + result
      var arr1_index = english[des_i]
      result = arr1[arr1_index] + result
    }
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
    result = result.replace(/零+$/, '') // 移除末尾的零
    result = result.replace(/^一十/g, '十')// 将【一十】换成【十】
    return result
  },
  $httpRequestList: [],
  // 取消当前所有请求
  cancelhttpRequest() {
    this.$httpRequestList.forEach(c => {
      c('取消请求');
    });
    this.$httpRequestList = [];
  }
};
Number.prototype.add = function(arg) {
  var r1, r2, m;
  try {
    r1 = this.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (this.mul(m) + Number(arg).mul(m)) / m;
};
//减法
Number.prototype.sub = function(arg) {
  return this.add(-arg);
};
//乘法
Number.prototype.mul = function(arg) {
  var m = 0,
    s1 = this.toString(),
    s2 = arg.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
};
//除法
Number.prototype.div = function(arg) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = this.toString().split('.')[1].length;
  } catch (e) {}
  try {
    t2 = arg.toString().split('.')[1].length;
  } catch (e) {}
  var len = Math.max(t1, t2);
  r1 = this * Math.pow(10, len);
  r2 = arg * Math.pow(10, len);
  return r1 / r2;
};
window.getMetaValue = tools.getMetaValue;
export default tools;
